"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumablesValidation = exports.ConsumablesDevicePage = exports.ConsumablesOrderBy = exports.CreateExportJobBody = exports.ExportFilters = exports.DevicePage = exports.OrderBy = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Pagination = __importStar(require("../../../../../../../pagination"));
const Device = __importStar(require("../../../../../../device"));
const Tenant = __importStar(require("../../../../../../tenant"));
const DeviceList = __importStar(require("../../../../../device/deviceList"));
const Common = __importStar(require("../../common"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.Devices.Schema';
/*
 * `controllers/v2/fleet/device.ts`, `device-export.ts`, `consumables.js`
 * and `utils/device/domain.ts`
 */
exports.OrderBy = effect_1.Schema.Literal('status', 'model', 'swVersion', 'errors', 'alarms', 'installationAddress', 'installationStatus').annotations({
    identifier: `${exports.NAMESPACE}.OrderBy`,
    title: 'Device sort key',
});
/** `PaginatedDevicesListResponse = Pagination.paginate(Culligan.Api.Device.DeviceList.Device)` */
exports.DevicePage = Pagination.paginate(DeviceList.Device).annotations({
    identifier: `${exports.NAMESPACE}.DevicePage`,
    title: 'Device page',
    description: 'One page of device list items matching the filters',
});
/**
 * `DevicesQueryParams` as captured in an export snapshot: the same filters
 * the list route takes, as JSON. One value or an array is accepted for the
 * multi-valued filters, as Express would parse them from a query string.
 */
exports.ExportFilters = effect_1.Schema.Struct({
    model: effect_1.Schema.optionalWith(Common.oneOrMany(Device.Class.Common.ModelCode), { exact: true }),
    status: effect_1.Schema.optionalWith(Common.ConnectionStatus, { exact: true }),
    search: effect_1.Schema.optionalWith(effect_1.Schema.Trim.pipe(effect_1.Schema.nonEmptyString()), { exact: true }),
    operatingMode: effect_1.Schema.optionalWith(Common.oneOrMany(Device.Class.Base.OperatingMode), { exact: true }),
    installationStatus: effect_1.Schema.optionalWith(Common.oneOrMany(Device.Class.Base.InstallationStatus), {
        exact: true,
    }),
    businessUnit: effect_1.Schema.optionalWith(Common.oneOrMany(Common.BusinessUnitCode), { exact: true }),
    ring: effect_1.Schema.optionalWith(Device.Class.Base.FilterableRing, { exact: true }),
    tenantIds: effect_1.Schema.optionalWith(Common.oneOrMany(Tenant.Id), { exact: true }),
    alarmTypes: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Capability.Alarm.AlarmTag), { exact: true }),
    alarmSeverities: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Capability.Alarm.Severity), { exact: true }),
    alarmDomains: effect_1.Schema.optionalWith(effect_1.Schema.ArrayEnsure(Device.Capability.Alarm.AlarmDomain), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ExportFilters`,
    title: 'DevicesQueryParams',
    description: 'Device filters captured for the export',
});
/** `CreateDevicesExportJobBody` */
exports.CreateExportJobBody = effect_1.Schema.Struct({
    filterSnapshot: exports.ExportFilters,
}).annotations({
    identifier: `${exports.NAMESPACE}.CreateExportJobBody`,
    title: 'CreateDevicesExportJobBody',
});
/*
 * `GET /v2/fleet/devices/consumables` (`consumables.js`) answers through
 * protocol v1: full device documents, v1 error bodies.
 */
exports.ConsumablesOrderBy = effect_1.Schema.Literal('id', 'model', 'name').annotations({
    identifier: `${exports.NAMESPACE}.ConsumablesOrderBy`,
    title: 'Consumables sort key',
});
/** `Pagination.paginate(Culligan.Device.Class.Device)` */
exports.ConsumablesDevicePage = Pagination.paginate(Device.Class.Device).annotations({
    identifier: `${exports.NAMESPACE}.ConsumablesDevicePage`,
    title: 'Consumables device page',
    description: 'One page of full device documents whose consumables of the requested category fall within the fill-level range',
});
/** 400 `{ message: "Validation Error", details }`: the v1 body `consumables.js` answers when the query does not decode. */
exports.ConsumablesValidation = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('Validation Error'),
        details: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
            description: 'Effect ParseError message',
        }),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ConsumablesValidation`,
    title: 'Consumables Validation Error',
    description: 'The query parameters do not decode or violate a cross-field rule',
    [platform_1.HttpApiSchema.AnnotationStatus]: 400,
});
//# sourceMappingURL=schema.js.map